import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    formInputStyles,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const RulePatternField = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            isInvalid={!!errors.pattern && touched.pattern}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired>
            <Stack
                direction="row"
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <Box w="200px">
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Pattern
                    </FormLabel>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="pattern"
                            name="pattern"
                            placeholder="Enter pattern"
                            validate={(value) =>
                                !value && 'Pattern is required'
                            }
                            {...props}
                        />
                        <FormErrorMessage>{errors.pattern}</FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="The Regex pattern used to identify specific number formats (Local, National, International). Use ^ for start, $ for end, and enclose the digits you want to keep in parentheses () to create a capture group."
                        ariaLabel="rule pattern tooltip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default RulePatternField;
